import { useState } from "react"
import { ToastContainer } from "react-bootstrap"
import Toast from "react-bootstrap/Toast"
import { TOAST_TYPE } from "../utils/config"

function ToastMessage({ type = TOAST_TYPE.SUCCESS, title, message, handleCloseCallback=null }) {
  const [show, setShow] = useState(true)
  const onClose = ()=>{
    setShow(false);
    if (handleCloseCallback && typeof handleCloseCallback === 'function') {
      // do something
      handleCloseCallback()
    }
  }
  return (
    <ToastContainer className="p-3" position={"top-end"} style={{zIndex:14000}}>
      <Toast
        show={show}
        onClose={() => onClose()}
        delay={3000}
        autohide
        bg={type}
      >
        {title && <Toast.Header>{title}</Toast.Header>}
        <Toast.Body>{message}</Toast.Body>
      </Toast>
    </ToastContainer>
  )
}

export default ToastMessage
